export interface DocumentTitleConfig {
  explicitTitle?: string | null;
}

export function normalizeDocumentTitleConfig(
  input: unknown,
): DocumentTitleConfig {
  if (!input || typeof input !== 'object') {
    return { explicitTitle: null };
  }

  const rec = input as Record<string, unknown>;
  const explicitTitle =
    typeof rec.explicitTitle === 'string' ? rec.explicitTitle.trim() : '';

  return {
    explicitTitle: explicitTitle || null,
  };
}
